import React, { Fragment, useState, useEffect } from 'react'
import { useProjects } from 'context/project-context'
import useAxios from 'axios-hooks'
import { getAuthHeader } from 'utils/auth'
import { useQueryParams, StringParam } from 'use-query-params'
import ScansTop from 'views/ScanSettings/Scans/components/ScansTop'
import ScansInfo from 'views/ScanSettings/Scans/components/ScansInfo'
import ScansData from 'views/ScanSettings/Scans/components/ScansData'
import { ErrorBoundary, PageAlert, ignoreTimeoutExceptions } from 'components'
import { useUser } from 'context/user-context'


function Scans({ scanSettingsId, navigate }) {
  const [query, setQuery] = useQueryParams({
    type: StringParam,
    owner: StringParam
  })
  const { project } = useProjects()
  const user = useUser()
  const [selectedScans, setSelectedScans] = useState([])
  const [{ data, loading, error }, fetchScans] = useAxios(
    {
      method: 'GET',
      url: `${project.name}/scan-settings/${scanSettingsId}/scans`,
      headers: getAuthHeader()
    },
    { manual: true }
  )

  let scans = (data && data.scans) || []
  let pageCount = data ? data.count : false

  useEffect(() => {
    fetchScans({ data: { ...query } });
    let interval = setInterval(() => {
      fetchScans({ data: { ...query }, timeout: 10000}).catch(() => {});
    }, 10000)
    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [query])

  let errorsMessage = ignoreTimeoutExceptions(error);
  
  return (
    <ErrorBoundary>
      {errorsMessage && <PageAlert message={errorsMessage} />}
      <ScansTop
        user={user}
        scanSettingsId={scanSettingsId}
        selectedScans={selectedScans}
        navigate={navigate}
        scanSettings={data}
        scanSettingsName={data && data.name}
        initialDisableRescan={data && data.disable_rescan}
        firstScan={data && data.scans.length == 0}
        fetchScans={fetchScans}
      />
      <ScansInfo data={data} loading={loading} />
      <ScansData
        data={scans}
        fetchScans={fetchScans}
        loading={loading}
        setSelectedScans={setSelectedScans}
        scanSettingsId={scanSettingsId}
        navigate={navigate}
        pageCount={pageCount}
      />
    </ErrorBoundary>
  )
}

export default Scans
